<template>
	<div id="sentiment_market_hot_trend">
		<div class="row">
			<div lass="col-2" style="width: 200px;">
				<b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1"
				class="mb-1" today-button close-button locale="zh"></b-form-datepicker>
			</div>
			<div class="col" style="width: 200px;">
				<b-form-checkbox
				size="sm"
				id="checkbox_auto_refresh"
				v-model.number="auto_refresh"
				name="checkbox_auto_refresh"
				value="1"
				unchecked-value="0"
				>
				自动刷新
				</b-form-checkbox>
			</div>
		</div>
		<!-- {{date1}} -->
		<v-chart class="chart_hot_trend" :options="line" :theme="echartsTheme" :key="echartsTheme" />
		<div class="text-right mb-1">
			<b-link v-b-toggle.hot-trend-usage class="text-muted small">使用说明 <b-icon icon="info-circle" /></b-link>
		</div>
		<b-collapse id="hot-trend-usage">
			<b-alert show variant="light" class="small py-2 mb-2">
				<ul class="mb-0">
					<li>按照日内分时来量化市场情绪，结合按天情绪来使用</li>
					<li>敏感情绪体现高位风险，比如瀑布出现</li>
					<li>敏感情绪体现早盘机会，比如早盘越界</li>
					<li>普通情绪体现综合市场的冷暖</li>
					<li>重点在于
						<ul>
							<li>A:按天情绪在过热时候的第一次分歧减仓，第二次分歧空仓</li>
							<li>B:按天情绪在过冷时候市场的企稳</li>
							<li>C:节点处试错，特别是下面空间板低位共振</li>
							<li>D:按天趋势形成向上后推仓位，早盘情绪有体现</li>
						</ul>
					</li>
				</ul>
			</b-alert>
		</b-collapse>
	</div>
</template>
<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'

	import {
		request_zzquant, request_zrx
	} from "network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	const downColor = '#00da3c';
	const downBorderColor = '#008F28';

	export default {
		props: {
			title: {
				type: String,
				default: "日内情绪热度"
			},
			subText: {
				type: String,
				default: "分时热度"
			},
			zoom_start: {
				type:  [Number, String],
				default: 70,
			},
			zoom_end: {
				type: Number,
				default: 100,
			}
		},
		mounted() {
			request_zrx({url:'/open/tradedays'}).then(
				res => {
					let days = res['data']['data'];
					this.date1 = days[days.length-1];
				}
			);
			this.refresh();
			this.timer = setInterval(() => {  //创建定时器 30s
				this.refresh_intervel();
			}, 30000);
			try{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }catch(e){ console.warn('theme read failed', e) }
			window.addEventListener('site-theme-changed', this.onThemeChanged)
		},
		components: {
			'v-chart': ECharts
		},
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
			return {
				theme:'light',
				hot_y_axis:{v_min:-5,v_max:6},
				auto_refresh:0,
				date1: today,
				timer: null, //首先我在data函数里面进行定义定时器名称
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0,
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					toolbox: { //下载
						show: true,
						feature: {
							saveAsImage: {}
						}
					},
					legend: {
						top: 10,
						left: 'center',
						data: ['主要情绪', '敏感情绪'],
						textStyle: {
							color: '#999999'
						},
					},
					color:['#4472C5','#cccccc', upColor,downColor],
					visualMap: [{
						// top: 10,
						// right: 10,
						type: 'piecewise',
						show: false,
						seriesIndex: [0],
						dimension: 1,
						pieces: [{
								min: parseFloat(0),
								max: parseFloat(1),
								color: upColor
							},
							{
								min: parseFloat(1.01),
								max: parseFloat(10),
								color: upBorderColor
							},
							{
								min: parseFloat(-2),
								max: parseFloat(0),
								color: downColor
							},
							{
								min: parseFloat(-10),
								max: parseFloat(-2),
								color: downBorderColor
							},
						],
						outOfRange: {
							symbol: 'rect',
							symbolSize: [1, 1],
							color: upBorderColor,
						}
					},
					{
						type: 'piecewise',
						show: false,
						seriesIndex: [1],
						dimension: 1,
						pieces: [{
								min: parseFloat(0),
								max: parseFloat(5),
								color: upColor
							},
							{
								min: parseFloat(5),
								max: parseFloat(10),
								color: upBorderColor
							},
							{
								min: parseFloat(-4),
								max: parseFloat(0),
								color: downColor
							},
							{
								min: parseFloat(-10),
								max: parseFloat(-4),
								color: downBorderColor
							},
						],
					}],
					xAxis: [{
							gridIndex: 0,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10,
								color: '#999999'
							},
						},
					],
					yAxis: [{
							gridIndex: 0,
							name: "情绪",
							scale: true,
							position: 'left',
							// min: 'dataMin',
							// max: 'dataMax',
							min: function(value){return value.min>-4?-4:value.min},
							max: function(value){return value.max<6?6:value.max},
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}%',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						},
						{
							gridIndex: 0,
							scale: true,
							offset: 2,
							min: 0,
							max: function(value){return value.max<100?100:value.max},
							splitArea: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: false,
							position: 'right',
						},
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: this.zoom_start,
						// 	end: this.zoom_end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0],
							y: '90%',
							start: this.zoom_start,
							end: this.zoom_end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: []
				}
			}
		},
		computed:{
			echartsTheme(){ return this.theme==='dark' ? 'site-dark' : null }
		},
		methods: {
			clearTimer() { //清除定时器
				clearInterval(this.timer);
				this.timer = null;
			},
			refresh_intervel(){
				if(Number(this.auto_refresh)){
					let  myDate = new Date();
					let day = myDate.getDay() //获取当前星期X(0-6,0代表星期天)
					let hour = myDate.getHours(); //获取当前小时数(0-23)
					if (0<day && day<6 && 9<=hour && hour<=15){
						this.refresh();
					}else{
						console.log("trend 非交易时间不刷新");
					}
				}
			},
			onDatePicked(ctx) {
				// console.log(ctx.selectedYMD);
				this.date1 = ctx.selectedYMD;
				this.refresh();
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			refresh() {
				let date = this.date1;
				axios.all([
						request_zzquant({
							'url': 'v3/api/sentiment/trend/0?date1=' + date
						}),
						request_zzquant({
							'url': 'open/sentiment/uplimit/trend?date1=' + date
						}),
						request_zzquant({
							'url': 'v3/api/sentiment/trend/1?date1=' + date
						}),
					])
					.then(axios.spread((resp1, resp2, resp3) => {
						let splitDataItem = this.splitData(resp1['data']['data'], resp2['data']['data'], resp3['data']['data']);
						let series_data = []
						// console.log(splitDataItem);
						series_data.push({
							name: '主要情绪',
							data: splitDataItem.pct,
							type: 'line',
							symbol: 'circle',
							showSymbol: true,
							xAxisIndex: 0,
							yAxisIndex: 0, // 对应上面定义的y轴数据的格式，数组的下标进行对应
							markLine: {
								data: [{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											width: 1,
											type: "solid",
											symbol: 'circle',
											color: upBorderColor,
										},
										label: {
											position: 'end',
											formatter: "沸腾"
										},
										yAxis: 3
									},
									{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											width: 1,
											type: "dotted",
											symbol: 'circle',
											color: upColor,
										},
										label: {
											position: 'end',
											formatter: "活跃"
										},
										yAxis: 1
									},
									{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											type: "dashed",
											color: "#AAA",
										},
										label: {
											position: 'end',
											formatter: "及格"
										},
										yAxis: 0
									},
									{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											type: "dashed",
											symbol: 'circle',
											color: downBorderColor,
										},
										label: {
											position: 'end',
											formatter: "冰凉"
										},
										yAxis: -2
									},
									{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											width: 1,
											type: "solid",
											color: downBorderColor,
										},
										label: {
											position: 'end',
											formatter: "冰点"
										},
										yAxis: -4
									}
								]
							},
							lineStyle: {
								normal: {
									width: 2,
									opacity: 1,
									// color: '#767477'
								}
							},

						});
						
						series_data.push({
							name: '敏感情绪',
							data: splitDataItem.pct_zrlb,
							type: 'line',
							symbol: 'circle',
							showSymbol: false,
							xAxisIndex: 0,
							yAxisIndex: 0, // 对应上面定义的y轴数据的格式，数组的下标进行对应
							lineStyle: {
								normal: {
									width: 2,
									opacity: 0.6,
									color: '#767477'
								}
							},
						});

						series_data.push({
							xAxisIndex: 0,
							yAxisIndex: 1, //数组里面的下标对应
							name: '自然涨停',
							data: splitDataItem.zrzt_num,
							type: 'line',
							symbol: 'circle',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: upColor
								}
							},
						});

						series_data.push({
							xAxisIndex: 0,
							yAxisIndex: 1, //数组里面的下标对应
							name: '炸板',
							data: splitDataItem.zb_num,
							type: 'line',
							symbol: 'circle',
							showSymbol: false,
							lineStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: downColor
								}
							},
						});

                        if (Array.isArray(this.line['xAxis']) && this.line['xAxis'][0]) {
                            this.line['xAxis'][0]['data'] = splitDataItem.categoryData
                        }
                        this.line['series'] = series_data;
						// this.line['legend'] = {
						// 	data: ['日内情绪', '自然涨停', '炸板'],
						// };
					}))
					.catch(err => {
						console.log(err);
					})
			},
            splitData(rawData, rowData2, rowData3) {
                let categoryData = []
                let pct = []
                let zb_num = []
                let zrzt_num = []
                let pct_zrlb = []
                if (Array.isArray(rawData)) {
                    rawData.forEach(item => {
                        if (item && item.length >= 2) {
                            categoryData.push(item[0])
                            pct.push(item[1])
                        }
                    })
                }
                const trendArr = rowData2 && Array.isArray(rowData2['trend']) ? rowData2['trend'] : []
                trendArr.forEach(item => {
                    if (item && item.length >= 3) {
                        zb_num.push(item[1])
                        zrzt_num.push(item[2])
                    }
                })
                if (Array.isArray(rowData3)) {
                    rowData3.forEach(item => {
                        if (item && item.length >= 2) {
                            pct_zrlb.push(item[1])
                        }
                    })
                }
                return {
                    categoryData,
                    pct,
                    zb_num,
                    zrzt_num,
                    pct_zrlb
                }
            }
		},

		created(){ this.onThemeChanged = (e)=>{ const t = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = t } },
		// 最后在beforeDestroy()生命周期内清除定时器：
		beforeDestroy() {
			window.removeEventListener('site-theme-changed', this.onThemeChanged)
			clearInterval(this.timer);
			this.timer = null;
		}
	}
</script>

<style scoped>
.chart_hot_trend {
	width: 100% !important;
	height: 400px !important;
}
</style>
